export const submitFormWithValues = (values: { [key: string]: unknown }, action: string, method = 'post') => {
  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', action);
  for (const key in values) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', values[key] as string);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
};
